import React from 'react';

export default function stopPropagation(e: React.BaseSyntheticEvent) {
  e.stopPropagation();
}
